import { render, staticRenderFns } from "./SubOfficeAggregation.vue?vue&type=template&id=6f850418&scoped=true"
import script from "./SubOfficeAggregation.vue?vue&type=script&lang=js"
export * from "./SubOfficeAggregation.vue?vue&type=script&lang=js"
import style0 from "./SubOfficeAggregation.vue?vue&type=style&index=0&id=6f850418&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f850418",
  null
  
)

export default component.exports